// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__t_FF8","title":"Info_title__31vwq","selects":"Info_selects__1FBTN","requiredAsterisk":"Info_requiredAsterisk__v4yds"};